(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    

  document.querySelectorAll('[data-hero-sound-toggle]').forEach(function (toggle) {
      var wrapper = toggle.closest('.hero__media-grid');
          if (!wrapper) return;

              function activeVideo() {
                    var isDesktop = window.matchMedia('(min-width: 750px)').matches;
                          var selector = isDesktop
                                  ? 'video[data-testid="hero-desktop-video-1"]'
                                          : 'video[data-testid="hero-mobile-video-1"]';
                                                return wrapper.querySelector(selector);
                                                    }

                                                        toggle.addEventListener('click', function () {
                                                              var video = activeVideo();
                                                                    if (!video) return;

                                                                          video.muted = !video.muted;

                                                                                if (!video.muted) {
                                                                                        video.play();
                                                                                              }

                                                                                                    toggle.setAttribute('aria-pressed', video.muted ? 'false' : 'true');
                                                                                                          toggle.setAttribute('aria-label', video.muted ? 'Tap for sound' : 'Mute sound');
                                                                                                              });
                                                                                                                });
                                                                                                                 
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
